import React, { useRef, useEffect } from "react";
import { Transition } from 'react-transition-group';

export const DropdownMenu = ({ item, index, open, handleDropdownClick, setActiveDropdown }) => {
  const transitionRef = useRef(null);
  const content = useRef(null);

  const defaultStyle = {
    transition: `opacity 300ms ease-in-out`,
    opacity: 0
  }

  const transitionStyles = {
    entering: { opacity: 1, visibility: 'visible' },
    entered:  { opacity: 1, visibility: 'visible' },
    exiting:  { opacity: 0, visibility: 'visible' },
    exited:  { opacity: 0, visibility: 'hidden' },
  };

  useEffect(() => {
    if (content) {
      content.current.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          const elements = content.current.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe");
          const first = elements[0];
          const last = elements[elements.length - 1];

          if (e.target === last && !e.shiftKey) setActiveDropdown(null);
          if (e.target === first && e.shiftKey) setActiveDropdown(null);
        }
      })
    }
  }, [content]);

  return (
    <div 
      className="relative"
      data-dropdown-parent
      ref={content}
    >
      <button 
        className="flex items-center gap-[0.375rem] py-4 uppercase"
        aria-expanded={open}
        aria-controls={`DropdownContent-${index}`}
        onClick={() => handleDropdownClick(index)}
        data-dropdown-trigger={`DropdownTrigger-${index}`}
      >
        <span className="pointer-events-none underline underline-offset-4 decoration-transparent hover:decoration-black transition uppercase">{item.title}</span>
        <svg aria-hidden="true" aria-focusable="false" width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg" className={`transition pointer-events-none ${open && `rotate-180`}`}>
          <path d="M4 4L0 0H8L4 4Z" fill="currentColor"/>
        </svg>
      </button>
      <Transition transitionRef={transitionRef} in={open} timeout={500}>
        {state => (
          <div 
            ref={transitionRef} 
            style={{
              ...defaultStyle,
              ...transitionStyles[state]
            }}
            className={`transition absolute bg-blush-100 -left-8 z-10 min-w-[18rem] px-8 pt-4 pb-5 ${open ? 'visible' : 'invisible'}`}
            id={`DropdownContent-${index}`}
          >
            <ul 
              id={`Menu-Dropdown-${index}`} 
              role="list"
            >
              {item.links.map((childlink, i, items) => {
                const isLast = i + 1 === items.length;
                return (
                  <li className="list-none">
                    <a 
                      href={childlink.url} 
                      className="py-[0.5rem] inline-block"
                      aria-current={childlink.current}
                    >
                      {childlink.title}
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </Transition>
    </div>
  )
}